module.exports = __webpack_public_path__ + "static/media/tyo.5751679b.webp";